import type {ReactElement} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import {exitWizardToOriginSurface, getWizardExitLabel} from '@Libraries/social-media-wizard-library';
import styles from './wizard-terminal-mobile-footer.module.scss';

export function WizardTerminalMobileFooter(): ReactElement {
  return (
    <footer className={styles.terminalMobileFooter}>
      <Button
        isFullWidth
        type={Type.SECONDARY}
        size={Size.SMALL}
        icon="icon-arrow-left"
        iconPlacement={IconPlacement.LEFT}
        iconClassName="size-icon-20"
        text={getWizardExitLabel()}
        onClick={exitWizardToOriginSurface}
      />
    </footer>
  );
}
